export type UserDetails = {
  userId: number;
  userName: string;
  firstName: string;
  lastName: string;
  title: string | null;
  email: string;
  gender: string;
  dateOfBirth: string;
  dateJoined: string;
  hasRequestedEmails: boolean;
  token: string | null;
  invitationCode: string | null;
  plan: string | null;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  userRoles: Array<UserRole>;
};

export enum UserRole {
  Student = "Student",
  Admin = "Admin",
  Tutor = "Tutor",
  SuperAdmin = "SuperAdmin",
}

export const IsAdmin = (roles: Array<UserRole>) => {
  return (
    roles.includes(UserRole.Admin) ||
    roles.includes(UserRole.Tutor) ||
    roles.includes(UserRole.SuperAdmin)
  );
};
